import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';
import LeaveTypeList from './pages/private/LeaveTypeList';
import API from '../middleware/API';
import { Link } from 'react-router-dom';
import { CalculateNormalHourMultipiler, CalculateHolidayHourMultipiler, GetStoreRole } from '../const/constant';

class ReviewOvertime extends Component {
  constructor(props) {
    super(props);
    this.state={
      isPay:false,
      startAt: moment(),
      endAt: moment(),
      overTimeHours: 0,
      reason:'',
      notes:'',
      pay:0,
      id:0,
      payType: '-1',
      staff:0,
      currentRole: GetStoreRole(localStorage.getItem('current_store_id'))
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handleLeaveTypeChange = this.handleLeaveTypeChange.bind(this);
    this.handleStaffTypeChange = this.handleStaffTypeChange.bind(this);
    this.handleSelectDateChange = this.handleSelectDateChange.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.fileInput = React.createRef();
    this.emptyAllField = this.emptyAllField.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot){
      if (!prevProps.isVisible && this.props.isVisible) {
          this.setState({ payType: '-1' });
        }
  }

  handleSelectStartTimeChange(moment) {    
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {    
    this.setState({
      selectEndTime: moment
    })
  }
  onValueChange(event) {
    var targerValue = (event.target.value === 'true');
    this.setState({
      //isPay: targerValue,
      payType: event.target.value,
    })
  }


  handleLeaveTypeChange(e) {  
    let leaveType = this.props.allLeaveType.find(leaveType => leaveType.id === parseInt(e.target.value))

    this.setState({
        leaveType: leaveType.id,
        notes: leaveType.notes,
        name: leaveType.name,
        beforeDay: leaveType.beforeDay,
        minHours: leaveType.minHours,
        wageTimes: leaveType.wageTimes,
        leavesDay: leaveType.leavesDay,
        deLeaveAmt: leaveType.deLeaveAmt,
    })
  }

  handleStaffTypeChange(e) {
    this.setState({
        staff: e.target.value
    })
  }

  handleReasonChange(e) {
    this.setState({
      reason: e.target.value
  })
  }
  diff = (start, end) => {
    start = start.split(":");
    end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0)
       hours = hours + 24;

    // if (hours + (minutes/60) > 8 && this.state.leaveType === 1)
    //   swal({
    //     type: 'error',
    //     title: '特休一天最多只能請8小時',
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     heightAuto: false,
    //     width: '250px'
    //   });
    if(hours + (minutes/60) > 8){
      //this.props.onChangeFunc('leaveHours', 8);
      return 8;
    }
    if((hours + (minutes/60) )> 0)
      //this.props.onChangeFunc('leaveHours', (hours + (minutes/60)));
    return hours + (minutes/60);
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen, longLeave,editTarget,isPartTime } = this.props;
    const { selectDate, selectStartTime,  selectEndTime, staff, reason, leaveType,currentRole} = this.state;
    if (editTarget.leaveItemId === 0) {
      swal({
        type: 'error',
        title: '尚未選取假別',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    // } else if (moment(editTarget.eDate).diff(moment(editTarget.sDate)) / 1000 / 60 / 60 > 8 && editTarget.leaveItemId === 1) {
    //   swal({
    //     type: 'error',
    //     title: '特休一天最多只能請8小時',
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     heightAuto: false,
    //     width: '250px'
    //   });
    //   return;
    } else if (moment(editTarget.eDate).diff(moment(editTarget.sDate)) <= 0) {
      swal({
        type: 'error',
        title: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (currentRole !== '4' && editTarget.agentUserId === 0) {
      swal({
        type: 'error',
        title: '請選擇職務代理人',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    this.emptyAllField();
    this.props.saveWorkRecordFunc(this.fileInput.current.files[0]);
    toggleOpen();
  }

  emptyAllField(){
    this.setState({
      leaveType: 0,
      payType: '-1',
      selectDate: moment(),
      selectStartTime: moment(),
      selectEndTime: moment(),
      reason:'',
      notes:'',
      dropReason:'-1',
      staff:0,
    })
  }
  
  handleSelectDateChange(moment) {
    this.setState({
      selectDate: moment
    })
  }
  handleCommentChange(e) {
    this.setState({
      notes: e.target.value
    })
  }
  handleDateChangeRaw = (e) => {
    e.preventDefault();
  }

  render() {
    let { isVisible, toggleOpen, targetDate, editTarget, onChangeFunc, targetEventId, longLeave,isProxy } = this.props;
    let{currentRole,notes, dropReason,payType}  = this.state;
    if (!isVisible) {
      return null;
    }
    let isDisable = editTarget.leaveItemId === 1 ? editTarget.remainHours <= 0 : false;

    var payStandard = editTarget.pay > 2000? editTarget.pay / 240 :editTarget.pay;
    return (
    <div className="p-staff-list">
        <div className="u-editblock fadeIn" onClick={toggleOpen}>
              <div className="form-block"  style={{minWidth:'400px', maxWidth:'80%'}} onClick={(e)=>{e.stopPropagation();}}>
    <div className="u-small-title">簽核加班單</div>
                <form className="u-form">
                <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：{moment(editTarget.applyDate).format('YYYY-MM-DD')}</label>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時間：{moment(editTarget.expectSignInTime).format('HH:mm')}~{moment(editTarget.expectSignOutTime).format('HH:mm')}</label>
                    </div>
                  </div>
                    {
                    editTarget.records?

                                  <>                    <div className="row">
                    
                                  {
                                    editTarget.records.data.map((item,index)=>{
                                      return <React.Fragment key={index}><div className="col-6 col-pad-12">
                                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>{editTarget.records.data.indexOf(item)===0?'打卡時段：':''}</label>
                                    </div><div className="col-6 col-pad-12"><label className="u-form__label text-align-right" style={{flex: '0 0 54px'}} key={item.id}>{item.actualSignInTime}~{item.actualSignOutTime}</label></div></React.Fragment>
                                    
                                  })}
                                
                              </div>
                     <div className="row">                          
                       <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>算薪工時：{editTarget.records.totalSalaryTime}小時</label>
                      </div>
                      <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>總時數：{editTarget.records.totalWorkTime.replace(':','時')}分</label>
                      </div>         
                     </div></>
                    :''
                  }

                    <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>加班時段：{moment(editTarget.startAt).format('HH:mm')}~{moment(editTarget.endAt).format('HH:mm')}</label>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>共{editTarget.overTimeHours}小時</label>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-6 col-pad-12">
                    <Link className="btn btn-md save" style={{color:'white'}} to={{ pathname: "https://drive.google.com/file/d/1EWlMTMh-PhK5U-QnsBI4TKVr9Fw6Lv-q/view?usp=drive_link" }} target="_blank">查詢加班費類別</Link>
                  
                    </div>
                  </div>
                  {
                    editTarget.isPartTime?
                    <div className="row">
                    <div className="col-5 col-pad-12">
                      <label className="u-form__label text-align-right">
                      <input
                        type="radio"
                        value="3"
                        checked={payType==3}
                        onChange={this.onValueChange}
                      /> 
                        休假日加班費:{(payStandard * CalculateHolidayHourMultipiler(editTarget.overTimeHours)).toFixed(0)}元</label>
                    </div>
                  </div>:
                    <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>
                      <input
                        type="radio"
                        value="1"
                        checked={payType==1}
                        onChange={this.onValueChange}
                      />                                
                      轉換補休時數：{editTarget.overTimeHours} 小時
                      </label>
                    </div>
                    <div className="col-5 col-pad-12">
                      <label className="u-form__label text-align-right">
                      <input
                        type="radio"
                        value="3"
                        checked={payType==3}
                        onChange={this.onValueChange}
                      /> 
                        休假日加班費:{(payStandard * CalculateHolidayHourMultipiler(editTarget.overTimeHours)).toFixed(0)}元</label>
                    </div>
                  </div>
                  
                  }
                  <div className="row">
                  

                    <div className="col-5 col-pad-12">
                      <label  style={{ color: editTarget.overTimeHours >4? 'gray' : 'black'}} className="u-form__label text-align-right">
                      <input
                        type="radio"
                        value="2"
                        //勞動基準法第32條：雇主延長勞工之工作時間連同正常工作時間，一日不得超過12小時； by 0118 秋雲

                        disabled={editTarget.overTimeHours >4}
                        checked={payType==2}
                        onChange={this.onValueChange}
                      /> 
                        加班費:{(payStandard * CalculateNormalHourMultipiler(editTarget.overTimeHours)).toFixed(0)}元</label>
                    </div>

                  <div className="col-5 col-pad-12">
                      <label className="u-form__label text-align-right">
                      <input
                        type="radio"
                        value="4"
                        checked={payType==4}
                        onChange={this.onValueChange}
                      /> 
                        國定假日:{(payStandard * editTarget.overTimeHours * 2).toFixed(0)}元</label>
                    </div>
                  </div>
                                    <div className="row">
                  

                    <div className="col-5 col-pad-12">
                      <label  style={{ color: editTarget.overTimeHours >4? 'gray' : 'black'}} className="u-form__label text-align-right">
                      <input
                        type="radio"
                        value="5"
                        //勞動基準法第32條：雇主延長勞工之工作時間連同正常工作時間，一日不得超過12小時； by 0118 秋雲
                        checked={payType==5}
                        onChange={this.onValueChange}
                      /> 
                        例假日加班:{(payStandard * editTarget.overTimeHours * 2).toFixed(0)}元 + {editTarget.overTimeHours} 小時</label>
                    </div>
                  </div>
                  <div className="row">
                  <div className="col-12 col-pad-12">
                  <label className="u-form__label text-align-right" style={{flex: '0 0 54px', fontWeight:'700'}}>加班原因：{editTarget.reason}</label>
                  </div>
                  </div>
                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>備註：</label>
                      <input type="text" className="u-form__input" value={notes} onChange={e=>this.handleCommentChange(e)}/>
                    </div>
                    <div className="col-6 col-pad-12">
                      <div className="u-btn-group right">
                        <button disabled={payType == '-1'} className={payType == '-1'?"btn btn-md disable":"btn btn-md success"}  type="button" onClick={() => {this.props.signingFunc(editTarget.id, '1',notes, this.state.payType);this.emptyAllField();}}>核准</button>
                        
                        {
                          isProxy?
                          <button className="btn btn-md delete" type="button" onClick={() => {this.props.signingFunc(editTarget.id, 'X',notes, this.state.payType);this.emptyAllField();}}>作廢</button>

                          :
                          <button className="btn btn-md slide-bar-font-color-active" type="button" onClick={() => {this.props.signingFunc(editTarget.id, 'R',notes, this.state.payType);this.emptyAllField();}}>退回</button>

                        }
                      </div>
                    </div>
                  </div>
                  <div className="row">
                  <div className="col-12 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**核准後不能修改**</label>
                    </div>
                    <div className="col-12 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**加班費類別必須要申請時數≤4才能選**</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
      </div>
    )
  }
}

export default ReviewOvertime;